import { SURVEY_LIST, SURVEY_LIST_FILTER_UPDATE, SURVEY_LIST_PAGE_UPDATE, SAVE_SURVEY, EDIT_SURVEY, SET_SAVE_SURVEY_STATUS,  PUBLISH_SURVEY, DELETE_SURVEY, UPDATE_SURVEY_DATE, UNMOUNT_ADDEDIT_SURVEY, GET_QUESTION_STATUS, RESET_QUESTION_STATUS } from '../constants/constants';


export const surveyList = () => {
    return {
        type: SURVEY_LIST
    }
}

export const updateSurveyListFilter = (data: any) => {
    return {
        type: SURVEY_LIST_FILTER_UPDATE,
        payload: data
    }
}

export const updateSurveyListPage = (data: any) => {
    return {
        type: SURVEY_LIST_PAGE_UPDATE,
        payload: data
    }
}

export const saveSurvey = (data: any) => {
    return {
        type: SAVE_SURVEY,
        payload: data
    }
}

export const setSaveSurveyStatus = () => {
    return {
        type: SET_SAVE_SURVEY_STATUS
    }
}

export const editSurvey = (data: any) => {
    return {
        type: EDIT_SURVEY,
        payload: data
    }
}

export const getQuestionStatus = (data: any) => {
    return {
        type: GET_QUESTION_STATUS,
        payload: data
    }
}

export const resetQuestionStatus = (data: any) => {
    return {
        type: RESET_QUESTION_STATUS,
        payload: data
    }
}

export const publishSurvey = (data: any) => {
    return {
        type: PUBLISH_SURVEY,
        payload: data
    }
}
export const updateSurveyDate = (data: any) => {
    return {
        type: UPDATE_SURVEY_DATE,
        payload: data
    }
}

export const deleteSurvey = (data: any) => {
    return {
        type: DELETE_SURVEY,
        payload: data
    }
}

export const unmountAddEditSurvey = (data: any) => {
    return {
        type: UNMOUNT_ADDEDIT_SURVEY,
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/action.survey.tsx